import React, {
  useRef,
  useLayoutEffect,
  createContext,
  useContext,
} from "react";
import { render } from "react-dom";

import { RawScore } from "./components.js";

export const InfoPopup = ({ children, iconGlyph = "comment" }) => {
  const buttonEl = useRef();
  useLayoutEffect(() => {
    // ~HACK: relies on Bootstrap+jQuery for expedience…
    function hidePopover() {
      // NOTE: using `.popover("hide")` breaks next click from re-opening :-/
      $(buttonEl.current).click();
    }
    function stopPropagation(evt) {
      evt.stopPropagation();
    }
    $(buttonEl.current)
      .popover({
        trigger: "click",
        container: "body",
        placement: "left",
        content: function () {
          let el = document.createElement("div");
          render(<>{children}</>, el);
          return el;
        },
        html: true,
      })
      .on("click", stopPropagation)
      .on("shown.bs.popover", function () {
        document.addEventListener("click", hidePopover, false);
      })
      .on("hidden.bs.popover", function () {
        document.removeEventListener("click", hidePopover, false);
      })
      // HT: https://stackoverflow.com/a/18717425
      .data("bs.popover")
      .tip()
      .addClass("info-popup-popup")
      .on("click", stopPropagation);

    return () => {
      // here it's actually better to hide, instead of just `return hidePopover;` helper
      // [otherwise a zombie popup somehow re-appears when parent element(s) come back?!]
      $(buttonEl.current).popover("hide");
    };
  }, []);
  return (
    <button type="button" className="info-popup" ref={buttonEl} tabindex="0">
      <span className={`glyphicon glyphicon-${iconGlyph}`} />
    </button>
  );
};

export const Survey = createContext();

export const RawNumber = ({ value }) =>
  value == null ? (
    <span class="value unavailable">-</span>
  ) : (
    <span class="value">{value}</span>
  );

export const RawPercent = ({ value }) =>
  value == null ? (
    <span class="percent unavailable">-</span>
  ) : (
    <span class="percent">{value}%</span>
  );

export const ToggleGroup = ({
  items,
  activeItem,
  setActiveItem,
  itemProps: getProps,
  eachLabel: getLabel = (d) => d.label,
  ...props
}) => (
  <div role="radiogroup" class="toggle-group" {...props}>
    {items.map((item) => (
      <span class="item-wrapper">
        <button
          type="button"
          role="radio"
          aria-checked={item === activeItem}
          {...(getProps && getProps(item))}
          onclick={(evt) => {
            setActiveItem(item);
            evt.preventDefault();
          }}
        >
          {getLabel(item)}
        </button>
      </span>
    ))}
  </div>
);

export const ResponseRatePanels = ({
  responseInfo,
  activeYear,
  alternateYear: altYear = null,
}) => {
  const survey = useContext(Survey);
  const mainInfo = responseInfo[activeYear._responses_index];
  const altInfo = altYear && responseInfo[altYear._responses_index];

  return (
    <>
      <div class="rate-panel">
        <h3>Response Rate:</h3>
        <p class="pct-details">
          <span class="main-pct">
            <RawNumber value={mainInfo.student_response_rate} />%
          </span>{" "}
          of your students (<RawNumber value={mainInfo.student_n} /> out of{" "}
          <RawNumber value={mainInfo.student_total_n} />) responded to this
          survey.
        </p>
        {altInfo && (
          <p class="alt-comparison">
            <span class="alt-pct">
              <RawNumber value={altInfo.student_response_rate} />%
            </span>{" "}
            responded to the <span class="alt-survey">fall survey</span>.
          </p>
        )}
      </div>
      <div class="rate-panel">
        <h3>Impact Question:</h3>
        <p class="pct-details">
          <span class="main-pct">
            <RawNumber value={mainInfo.student_fidelity_rate} />%
          </span>{" "}
          of respondents agreed with the statement: I believe my answers will be
          used to make my {survey._is4Coaches ? "class" : "school"} better.
        </p>
        {altInfo && (
          <p class="alt-comparison">
            <span class="alt-pct">
              <RawNumber value={altInfo.student_fidelity_rate} />%
            </span>{" "}
            of respondents agreed on the{" "}
            <span class="alt-survey">fall survey</span>.
          </p>
        )}
      </div>
    </>
  );
};

export const SimpleMeasuresTable = ({
  measures,
  label = "Measure",
  activeYear: y = null,
}) => (
  <table class="measures-table">
    <thead>
      <tr>
        <th>{label}</th>
        <th>Score</th>
      </tr>
    </thead>
    <tbody>
      {measures.map((m) => (
        <tr>
          <td>{m.compName ?? m.name}</td>
          <td>
            <RawScore result={m._results[y?._result_index ?? "latest"]} />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
